import styled from 'styled-components/macro';

import TableBody from 'components/data-visualization/Table/Body';
import Table from 'components/data-visualization/Table/Table';

import { ThemeProps } from 'types/styled';

export const TableBodyBottomBorder = styled(TableBody)`
  @media screen and (min-width: 60em) {
    tr:last-child td {
      border-bottom: 1px solid ${({ theme }): string => theme.Grey};
    }
  }
`;

export const FixedWidthPosition = styled.span<any>`
  @media screen and (min-width: 50em) {
    min-width: 2em;
  }
  font-weight: 600;
  text-align: right;
  display: inline-block;
  margin: ${({ margin }): string => margin};
`;

export const TitleWithIcon = styled.div`
  div,
  svg {
    display: inline-block;
    vertical-align: middle;
  }
`;

export const TableWithMinWidth = styled(Table)<ThemeProps<'table'>>`
  @media screen and (min-width: 60em) {
    min-width: ${(props: any): string => (props.wide ? '40em' : '30em')};
    position: relative;
  }
`;
